export const FETCH_DIARY = 'FETCH_DIARY';
export const FETCH_DIARIES = 'FETCH_DIARIES';
export const FETCH_DIARIES_SUCCESS = 'FETCH_DIARIES_SUCCESS';
